import UserMasquerade from 'components/userMasquerade/UserMasquerade';

export default UserMasquerade;
